import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditTipoBonoComponent } from "./edit-tipobono/edit-tipobono.component";

@Component({
  selector: "app-tipobono",
  templateUrl: "./tipobono.component.html",
  styleUrls: ["./tipobono.component.scss"],
})
export class TipoBonoComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditTipoBonoComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
